export default __webpack_public_path__ + "images/VY.e3a423d.png";